import { Injectable } from "@angular/core";
import { ActivatedRoute, CanActivate, Router, UrlTree } from "@angular/router";
import { AuthenticationService } from "../authentication.service";

@Injectable({ providedIn: "root" })
export class RouteGuardService implements CanActivate {
  constructor(
    private router: Router,
    private authSetting: AuthenticationService,
    private route: ActivatedRoute,
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.authSetting.isAdmin) {
      return true;
    } else {
      // Authenticated but not permitted: route to the unauthorized page
      // instead of logging the user out / sending them to login.
      return this.router.parseUrl("/pages/unauthorized");
    }
  }
}
